class FilterTypesEnum {
    static Input = 'input';
    static SelectSimple = 'selectSimple';

    static SelectMulti = 'selectMulti';
}

export {FilterTypesEnum}